"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PixelDebugRow;

var _lodash = require("lodash");

var _react = _interopRequireDefault(require("react"));

var _PixelmonPropTypes = _interopRequireDefault(require("./PixelmonPropTypes"));

function PixelDebugRow(_ref) {
  var pixelConfig = _ref.pixelConfig,
      onClick = _ref.onClick;
  var name = pixelConfig.name,
      event = pixelConfig.event;
  var style = onClick ? {
    cursor: 'pointer',
    textDecoration: 'underline'
  } : {};
  return /*#__PURE__*/_react["default"].createElement("tr", {
    className: "pixel-debug-row",
    style: style,
    onClick: onClick || _lodash.noop
  }, /*#__PURE__*/_react["default"].createElement("td", null, name), /*#__PURE__*/_react["default"].createElement("td", null, event));
}